let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("bbS1c")]).then(() => parcelRequire('jRIB1'));